import { useTheme } from "@mui/system";
import { Tooltip } from "@mui/material";

import { useTranslate } from "src/locales";
import { OrganizationCandidateType } from "src/services/candidates/candidates.types";

import Iconify from "src/components/iconify";

type LabelProps = {
  type?: OrganizationCandidateType;
  size?: number;
};

export function OrgCandidateTypeIcon({ type, size = 20 }: LabelProps) {

  const { t } = useTranslate();

  const theme = useTheme();

  const getIcon = () => {
    switch (type) {
      case OrganizationCandidateType.UNLINKED:
        return "fluent:person-prohibited-32-regular";
      case OrganizationCandidateType.LINKED:
        return "fluent:person-link-16-filled";
      default:
        return "akar-icons:unverified-fill";
    }
  }

  const getColor = () => {
    switch (type) {
      case OrganizationCandidateType.UNLINKED:
        return "gray";
      case OrganizationCandidateType.LINKED:
        return theme.palette.primary.main;
      default:
        return "gray";
    }
  }

  return (
    <Tooltip title={t(`candidates.detail.type_tooltips.${type}`)}>
      <Iconify icon={getIcon()} width={size} height={size} color={getColor()} />
    </Tooltip>
  )
}
